<div class="content">
  <div class="card" *ngIf="isCertificateActive() | async">
    <div class="card-body text-center">
      <img class="mt-4" width="80" src="./assets/images/icons/medal.png"/>
      <h1 class="my-4">CERTIFICATE</h1>
      <h5 class="font-weight-light mb-5">This is official Social Auditor confirmed account certification.</h5>
      <p *ngIf="(certificateState | async).certificate !== null">
        Certificate expires: {{(certificateState | async).certificate.expiry_at | date:'short'}}
      </p>
      <div class="corner-btn">
        <app-copy-href></app-copy-href>
      </div>
    </div>
  </div>
  <div class="card" *ngIf="!(isCertificateActive() | async) && (certificateState | async).certificate !== null">
    <div class="card-body text-center">
      <img class="mt-4" width="80" src="./assets/images/icons/medal.png"/>
      <h1 class="my-4">CERTIFICATE</h1>
      <h5 class="font-weight-light mb-5">Certificate has been expired.</h5>

    </div>
  </div>
  <div *ngIf="(certificateState | async).certificate !== null && (isCertificateActive() | async)">
    <app-profile-audit type="profile" [id]="(certificateState | async).certificate.audit_id"></app-profile-audit>
  </div>
</div>

